import { makeStyles, Theme } from '@material-ui/core';

export const useISStyle = makeStyles((theme: Theme) => {
    return {
        subtitle: {
            paddingTop: '0!important',
            '& .MuiListItemText-root': {
                marginTop: 0,
            },
            '& .MuiTypography-root': {
                fontWeight: theme.typography.fontWeightBold,
            },
        },
    };
});
